<template>
  <div id="table">
    <Spinner v-if="isLoading"/>

    <!-- table search -->
    <div v-if="category != 'overview' && category != 'calendar' && category != 'search'" id="table-search" class="flex flex-align-items-end">
      <div class="sav-search">
            <div class="flex flex-wrap">
                <div class="input-container">
                    <h3>Στοιχεία Ασφαλιζόμενου</h3>
                    <input v-on:keyup.enter="onSearchHandler" class="flex-1" type="text" v-model="searchDetailsQuery" :placeholder="searchDetailsPlaceholder">
                </div>
                <div class="input-container">
                    <h3>Περιοχή</h3>
                    <input v-on:keyup.enter="onSearchHandler" class="flex-1" type="text" v-model="searchRegionQuery" :placeholder="searchRegionPlaceholder">
                </div>
            </div>
            <div class="sav-search-footer">
                <div v-if="errorMsg" id="error-msg" class="flex flex-align-items-center">
                    <b>{{ errorMsg }}</b>
                </div>
                <div v-if="resultNum" id="results-num-msg" class="flex flex-align-items-end">
                    <b>{{ resultNum }}</b>
                </div>
                <button @click="onSearchHandler" type="submit" class="sav-btn sav-btn-red">Αναζήτηση</button>
            </div>
        </div>
    </div>

    <table :class="'sav-table ' + category" v-if="visibleRows.length">
      <!-- table headers -->
      <tr>
        <th v-for="(value, key, index) in tableHeaders" :key="index">{{ value }}</th>
      </tr>
      <!-- table rows -->
      <!-- <router-link tag="tr" :to="'/' + getType(row.type) + '/' + row.id" v-for="row in visibleRows"  -->
      <tr v-for="row in visibleRows"
        :id="getType(row.type) + '-' + row.id"
        :key="getType(row.type) + '-' + row.id" 
        :class="{ red: isExpired(row.end_date), yellow: isGoingToExpire(row.end_date), blue: isEqual(row.dept, 'Stavros'), green: isEqual(row.dept, 'Asprovalta') }">
        <td v-for="(value, key, index) in row" 
          v-show="key != 'id' && key != 'vat' && key != 'dept'"
          :key="index"
          @click="navigateTo(row, key)">
          <img v-if="(category == 'overview' || category == 'calendar' || category == 'search') && (key == 'type')" :src="require('./../assets/icons/' + value + '.png')"/>
          <span v-else-if="key == 'start_date' || key == 'end_date' || key == 'birth_date'">{{ formatDate(value) }}</span>
          <div v-else-if="key == 'id' || key == 'vat'"></div>
          <div v-else-if="(key == 'informed') && (value) && (isGoingToExpire(row.end_date) || isExpired(row.end_date))">
            <input type="checkbox" @change="setInformed(row, false)" checked>
          </div>
          <div v-else-if="(key == 'informed') && (!value) && (isGoingToExpire(row.end_date) || isExpired(row.end_date))">
            <input type="checkbox" @change="setInformed(row, true)">
          </div>
          <span v-else-if="(key == 'informed') && (!value)"></span>
          <span v-else>{{ value }}</span>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import axios from 'axios';
import Spinner from './Spinner.vue'

export default {
  props: ['category', 'tableHeaders', 'tableRows'],
  components: {
    Spinner
  },
  data() {
      return {
        name: 'Table',
        apiUrl : this.$parent.apiUrl,
        isLoading: false,
        visibleRows: '',
        searchDetailsQuery: '',
        searchRegionQuery: '',
        searchDetailsPlaceholder: '',
        searchRegionPlaceholder: 'Περιοχή',
        errorMsg : false,
        resultNum: ''
      }
  },
  methods: {
    getResultHeader (length) {
      return length > 1 ? "Βρέθηκαν " + length + " ασφάλειες." :  "Βρέθηκε 1 ασφάλεια."
		},
    isEqual: function (dept, location) {
      // true when dept equals location
      return dept == location;
    },
    isExpired: function (date) {
      // true when date is in the past
      return new Date(date) < new Date()
    },
    isGoingToExpire: function (date) {
      // true when date is in the next 30 days
      let now = new Date(),
        nowPlus30 = new Date(),
        expirationDate = new Date(date);

      nowPlus30.setDate(now.getDate() + 30);
      return (expirationDate > now) && (expirationDate < nowPlus30) 
    },
    formatDate: function (date) {
      // format date dd/mm/yyyy
      let now = new Date(date);

      return this.sliceNumber(now.getDate(), 2) + "/" + this.sliceNumber(now.getMonth() + 1, 2) + "/" + this.sliceNumber(now.getFullYear(), 4)
    },
    sliceNumber: function(number, slice) {
      // return number with custom number of digits
      return ("0" + number).slice(-1 * slice);
    },
    getType: function(rowType) {
      // return type of row
      // if overview, row type is known from data
      // in any other case, row type is known from the category
      return (this.category == "overview" || this.category == "calendar" || this.category == 'search') ? rowType : this.category;
    },
    setInformed (row, status) {
      this.tableRows.map(v => v.id === row.id ? v.informed = status : v.informed)
      this.visibleRows.map(v => v.id === row.id ? v.informed = status : v.informed)

      const vm = this;
      this.isLoading = true;
      
      let formData = '';
      const url = this.apiUrl + '/post/informed';
      const headers = { 
        headers: {
        'Content-type': 'application/json',
        }
      };

      formData = {
        user: JSON.parse(localStorage.getItem('sav-erp-user')),
        token: this.$cookie.get('sav-erp-token'),
        refreshToken: this.$cookie.get('sav-erp-refresh-token'),
        category: this.getType(row.type),
        id: row.id,
        informed: status,
        modified_by: JSON.parse(localStorage.getItem('sav-erp-user')).username
      };

      // post request update
      axios.post(url, formData, headers)
        .then(response => {
          if (response.status == 200) {
            this.errorMsg = "";
            this.isLoading = false;
          } else {
            this.errorMsg = response.status + "--" + response.statusText;
            this.isLoading = false;
          } 
        })
        .catch(error => {
          let response = error.response;
          
          if (response.status == 401) {
            localStorage.removeItem('user');    
            vm.$cookie.delete('sav-erp-token');
            vm.$cookie.delete('sav-erp-refresh-token');
            vm.$router.push("/login");
          } else {
            vm.errorMsg = response.data ? response.data : response.status + " - " + response.statusText;
            vm.isLoading = false;
          }
        });
    },
    navigateTo (row, clickedKey) {
      if (clickedKey !== 'informed') {
        this.$router.push('/' + this.getType(row.type) + '/' + row.id)
      }
    },
    onSearchHandler () {
      this.resultNum = ''
      this.errorMsg = ''

      let searchDetailsString = this.searchDetailsQuery.replace(/\s/g, '').length;
      let searchRegionString = this.searchRegionQuery.replace(/\s/g, '').length;
      // update visible rows based on search query
      if (searchDetailsString || searchRegionString) {
        // this.searchRegionQuery = '';
        if (this.category == "house" || this.category == "health") {
          // there is no plate in house and health
          this.visibleRows = this.tableRows.filter(o => (
            (
              o.name.toUpperCase().includes(this.searchDetailsQuery.toUpperCase()) || 
              o.telephone.toUpperCase().includes(this.searchDetailsQuery.toUpperCase()) || 
              o.vat.toUpperCase().includes(this.searchDetailsQuery.toUpperCase())
            ) && o.region.toUpperCase().includes(this.searchRegionQuery.toUpperCase())
          ));
        } else {
          this.visibleRows = this.tableRows.filter(o => (
            (
              o.name.toUpperCase().includes(this.searchDetailsQuery.toUpperCase()) || 
              o.telephone.toUpperCase().includes(this.searchDetailsQuery.toUpperCase()) || 
              o.vat.toUpperCase().includes(this.searchDetailsQuery.toUpperCase()) || 
              o.plate.toUpperCase().includes(this.searchDetailsQuery.toUpperCase())
            ) && o.region.toUpperCase().includes(this.searchRegionQuery.toUpperCase())
          ));
        }
      } else {
        this.visibleRows = this.tableRows;
      }

      if (this.visibleRows.length) {
        this.resultNum = this.getResultHeader(this.visibleRows.length);
      } else {
        this.errorMsg = 'Δεν υπάρχουν δεδομένα.'
      }
    }
  },
  created: function() {
    this.visibleRows = this.tableRows;
    if (this.category == "house" || this.category == "health") {
      this.searchDetailsPlaceholder = "Όνομα, ΑΦΜ, Τηλέφωνο";
    } else {
      this.searchDetailsPlaceholder = "Όνομα, ΑΦΜ, Πινακίδα, Τηλέφωνο";
    }
	}
}
</script>

<style lang="scss" scoped>
@import "./../scss/_colors";

@import "./../scss/_colors";
	@import "./../scss/_mq";

	.sav-search {
    display: flex;
    flex-direction: column;
    width: 100%;
		margin-bottom: 30px;
	}
	
	.input-container {
		flex: 1;
		margin-bottom: 30px;

		&:not(:last-child) {
            margin-right: 20px;
        }

		h3 {
			margin-top: 0;
			color: $blue;
			border-bottom: 2px solid $blue;
			font-size: 20px;
			font-weight: 500;
			margin-bottom: 15px;
		}
	}
	
	.sav-search-footer {
		display: flex;
		justify-content: flex-end;
	}

	#error-msg {
		color: $red;
		font-weight: 400;
		padding: 10px;
		margin-right: 10px;
	}

	#results-num-msg {
		color: $blue;
		font-weight: 400;
		padding: 10px;
		margin-right: 10px;
	}

.error-msg {
  color: $red;
  padding: 10px;
  margin-right: 10px;
}

#results-num-msg {
  color: $blue;
  padding: 10px;
  margin-right: 10px;
}
</style>
